import { Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { ToastrService } from 'ngx-toastr';

import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms'
import { AuthService } from '../../../services/auth.service'
import { UserService } from '../../../services/user.service'
import { Router } from '@angular/router';


@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {

  email!: FormControl
  password!: FormControl
  userId: null
  emailForm: FormGroup
  otpSection = false
  otp:any = null
  userInfo: any
  phoneNumber!: null
  submitted = false

  constructor(private formBuilder: FormBuilder, private router: Router, private authService: AuthService, private userService: UserService, private toastr: ToastrService) {
    this.userId = this.authService.getUser()
    this.emailForm = this.formBuilder.group({
      email: [null, Validators.compose([
        Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))+$/)
      ])],
      password: [null, Validators.compose([
        Validators.required,
        Validators.minLength(6)]),
      ],
    })

  }

  ngOnInit() {
  }
  // O_TRUNC
  addLabelClass(e:any) {
    $(e.target.parentElement.children[1]).addClass('animatedLabel')
  }

  goBack() {
    this.router.navigateByUrl('/doctor/homepage')
  }

  removeLabelClass(e:any) {
    if (e.target.value == '') {
      $(e.target.parentElement.children[1]).removeClass('animatedLabel')
    }
  }

  checkEmailPassword() {
    this.submitted = true
    if (!this.emailForm.invalid) {
      let params = {
        user_id: this.userId,
        email: this.emailForm.controls['email'].value,
        password: this.emailForm.controls['password'].value
      }
      this.userService.checkEmailPassword(params).subscribe((response:any) => {
        if (response.success) {
          this.submitted = false
          this.phoneNumber = response.phone_number
          this.otpSection = true
          this.otp = null
          setTimeout(function () {
               const otpElement = document.getElementById("otp");
            if (otpElement) { // Check if otpElement is not null
              otpElement.focus();
            }
          }, 200)
          setTimeout(function () {
            $('#resend-otp').removeClass('not-active')
          }, 120000);
        } else {
          this.toastr.error(response.error)
        }
      })
    }

  }

  changeEmail() {

    if (!this.otp) {
      this.otp = null
      this.toastr.error("Please enter valid OTP or click on resend button to receive new OTP")
    }
    else if (this.otp.length < 6) {
      this.otp = null
      this.toastr.error("Please enter valid OTP or click on resend button to receive new OTP")
    } else {
      let params = {
        user_id: this.userId,
        email_id: this.emailForm.controls['email'].value,
        password: this.emailForm.controls['password'].value,
        otp_action: 'change_email',
        otp: this.otp
      }
      this.userService.updateUser(params).subscribe((response:any) => {
        if (response.success) {
          this.otp = null
          this.otpSection = false
          this.emailForm.reset()
          this.toastr.success("Email updated successfully")
        } else {
          this.toastr.error(response.error)
        }
      })
    }
  }

  reqOtp() {

    let params = {
      phone_number: this.phoneNumber,
      otp_action: 'change_email',
      user_id: this.userId
    }

    this.userService.generateOTP(params).subscribe((response:any) => {
      if (response.success) {
        $('#resend-otp').addClass('not-active')
        setTimeout(function () {
          $('#resend-otp').removeClass('not-active')
        }, 12000);
        this.toastr.success("OTP has been sent to your registered mobile number")
      } else {
        this.toastr.error(response.error)
      }
    })
  }

  validateNumber(e:any) {
    return (e.charCode > 47 && e.charCode < 58) || (e.which == 8) || (e.keyCode == 9) || (e.which == 13)
  }


  onKeyUp(event:any, id:any, nextInputIndex:any) {
    let keyCodeValue = event.keyCode;
    let input = event.target;
    let nexInput, newID;

    if (keyCodeValue != 32 && (event.key >= 0 && event.key <= 9) || keyCodeValue == 8 || keyCodeValue == 13) {
      if (keyCodeValue === 8) {
        nexInput = nextInputIndex - 1;
        newID = id + nexInput;
      } else if (keyCodeValue === 9) {
        nexInput = nextInputIndex;
        newID = id + nexInput;
      } else {
        nexInput = nextInputIndex + 1;
        newID = id + nexInput;
      }
      if (nexInput <= 5 && nexInput >= 0) {
           const newIDElement = document.getElementById(newID);
        if (newIDElement) { // Check if newIDElement is not null
          newIDElement.focus();
        }
      }
    } else {
      $('#tab' + nextInputIndex).val('');
      return false;
    }
  }

}